import React from "react";

import { useTranslation } from "react-i18next";

import "../../../css/admin/comments.scss";
import Button from "../../button/Button";
import NavbarAvatarImage from "../../common/header/NavbarAvatarImage";

import type { JSX } from "react";

import type { CommentUser } from "../comment.types";

interface UserThreadProps {
  user: CommentUser;
}

function UserThread({ user }: UserThreadProps): JSX.Element {
  const { t } = useTranslation("editor-comments");

  return (
    <div className="editor-user-thread-container">
      <NavbarAvatarImage avatar_url={user.avatar_url} />
      <p className="user-thread-name">
        {" "}
        {user.first_name} {user.last_name}{" "}
      </p>
      <Button
        isFullWidth
        onClick={() => window.open(`mailto:${user.email}`, "_blank")}
        size="sm"
        type="button"
      >
        {t("contact")}
      </Button>
    </div>
  );
}

export default UserThread;
